module.exports = __webpack_public_path__ + "img/no-data.9e2f458e.svg";